import React from "react";

/**
 * Para aplicação de estilo em substituição ao uso incorreto do elemento '<label>'
 */
const Label = ({ children }) => <span>{children}</span>;

export default Label;
